import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Swiper from 'react-id-swiper';
import { BgImage, SingleLineCaption } from './../../components';
import Popover from './../../components/popover/Popover';

class ExPubSwiper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popover: false,
      currentImage: this.props.Slides[0].urls.id,
      thumbClicked: null,
      clicks: 0
    };
  }

  _slideChange() {
    const swiperIndex = this.swiper.realIndex;
    const currentSlide = this.props.Slides[swiperIndex].urls.id;
    this.setState({
      currentImage: currentSlide
    });
  }

  _closePopup() {
    this.setState({
      popover: false
    });
  }

  _clickPopupDesktop(id) {
    this.setState({
      currentImage: id,
      popover: true
    });
  }

  render() {
    const GalleryItems = this.props.Slides.map((item, i) =>
      <div className={'ex-pub__slide'} key={`pub-slide__${item.urls.id}-${i}`}>
        <div className={'slide-img-wrapper'} onClick={() => this._clickPopupDesktop(item.urls.id)}>
          <BgImage bgSize={'contain'} source={item.urls.large} />
        </div>
        <SingleLineCaption Headline={item.metadata.title} Description={item.metadata.caption}/>
        <style jsx>{`
          .ex-pub__slide {
            height: calc(50vh + 6rem);
            opacity: .25;
            transition: opacity 750ms ease;
            will-change: opacity;
            text-align: center;
          }
          .slide-img-wrapper {
            height: 50vh;
            cursor: pointer;
          }
          @media (min-width: 640px) {
            .ex-pub__slide {
              height: calc(70vh + 6rem);
            }
            .slide-img-wrapper {
              height: 70vh;
            }
          }
          :global(.swiper-slide > .caption-wrapper) {
            transition: opacity 1000ms ease 250ms;
            will-change: opacity;
            opacity: 0;
            padding-top: 2rem;
          }
          :global(.swiper-slide-active) {
            opacity: 1!important;
          }
          :global(.swiper-slide-active > .caption-wrapper) {
            opacity: 1!important;
          }
        `}</style>
      </div>
    );

    const swiperParams = {
      slidesPerView: 3,
      spaceBetween: 100,
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20
        }
      },
      centeredSlides: true,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      loopAdditionalSlides: 5,
      navigation: {
        nextEl: '.ep_swiper-next',
        prevEl: '.ep_swiper-prev'
      },
      pagination: {
        clickable: true,
        loop: true
      },
      on: {
        slideChange: () => {
          this._slideChange();
        }
      }
    };

    return (
      <Fragment>
        {(this.state.popover) && <Popover Images={this.props.Slides} CurrentImage={this.state.currentImage} ClickFunction={() => this._closePopup()}/>}
        <section id='ex-pub__slider'>
          <div id={'ex-pub__wrapper'}>
            <Swiper {...swiperParams} ref={node => { if (node) this.swiper = node.swiper; }}>
              {GalleryItems}
            </Swiper>
          </div>
          <style jsx>{`
            #ex-pub__slider {
              width: 100%;
              position: relative;
              top: 0;
              left: 0;
              margin: 6rem auto;
              overflow-x: hidden;
            }
            #ex-pub__wrapper {
              width: 100vw;
              position: relative;
              left: 0;
              top: 0;
            }
            #ex-pub__slider,
            #ex-pub__wrapper {
              height: calc(50vh + 6rem);
            }
            @media (min-width: 640px) {
              #ex-pub__slider,
              #ex-pub__wrapper {
                height: calc(70vh + 6rem);
              }
            }
            :global(#ex-pub__wrapper > .swiper-container) {
              width: 170vw;
              position: absolute;
              top: 0;
              left: 0;
              transform: translateX(-35vw);
            }
            :global(.ep_swiper-next),
            :global(.ep_swiper-prev) {
              position: absolute;
              height: 100%;
              top: 0;
              width: 25vw;
              cursor: pointer;
              background-size: contain;
              background-repeat: no-repeat;
              background-position: center;
              color: transparent;
              background-color: transparent;
              outline: none;
              z-index: 12000;
              opacity: .85;
              text-transform: uppercase;
            }
            :global(.ep_swiper-prev) {
              left: 35vw;
              cursor: url('/static/icons/arrow-left-cursor.svg'), auto;
            }
            :global(.ep_swiper-next) {
              right: 35vw;
              cursor: url('/static/icons/arrow-right-cursor.svg'), auto;
            }
          `}</style>
        </section>
      </Fragment>
    );
  };
};

export default connect(
  state => ({
    window_width: state.window_dimensions.window_width
  })
)(ExPubSwiper);



// WEBPACK FOOTER //
// ./src/pages/ex-pub-gallery/ExPubSwiper.js